import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconCommand",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--command"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Command",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.586 1.586A2 2 0 0 1 5 3v1h2V3a2 2 0 1 1 2 2H8v2h1a2 2 0 1 1-2 2V8H5v1a2 2 0 1 1-2-2h1V5H3a2 2 0 0 1-1.414-3.414ZM4 4V3a1 1 0 1 0-1 1h1Zm1 1v2h2V5H5ZM4 8H3a1 1 0 1 0 1 1V8Zm4 0v1a1 1 0 1 0 1-1H8Zm0-4h1a1 1 0 1 0-1-1v1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, c);
}
const H = /* @__PURE__ */ s(m, [["render", u]]);
export {
  H as default
};
//# sourceMappingURL=command.js.map
